export function formatDate(dateStr: string) {
    const date = new Date(dateStr);
    const now = new Date();
    const diffInMs = now.getTime() - date.getTime();
    const diffInHours = diffInMs / (1000 * 60 * 60);

    if(diffInHours < 24) {
        return date.toLocaleTimeString('sk-SK', { hour: '2-digit', minute: '2-digit' });
    }

    return date.toLocaleDateString('sk-SK', { day: '2-digit', month: '2-digit' });
}
